import React, { createContext, PropsWithChildren } from "react";

import { AuthorProps } from "@brexhq/next/src/components/shared/AuthorList/AuthorList";
import { formatContentHubArticleDate } from "@brexhq/next/src/utils/dates/formatting";

interface ConsumerValue {
  articleDate: string;
  authors?: AuthorProps[];
  readTime: number /* time in minutes from word count */;
  title: string;
}
interface Article {
  meta: {
    title: string;
    description: string;
    ogImage?: {
      image?: { datUrl: string };
    };
  };
  readTime: number;
}
export interface ContentHubArticle extends Article {
  readonly _type: "contentHubArticle";
  contentHubArticleContent: {
    corePageBuilder: any;
    authors?: AuthorProps[];
    articleDate: string;
  };
}
export interface PressArticle extends Article {
  readonly _type: "pressRelease";
  pressReleaseContent: {
    corePageBuilder: any;
    articleDate: string;
  };
}
interface ProviderProps {
  data: ContentHubArticle | PressArticle;
}

export const ArticleContext = createContext<ConsumerValue>({
  articleDate: "",
  readTime: 1,
  title: "",
});

export const ArticleContextProvider: React.FC<
  PropsWithChildren<ProviderProps>
> = ({ children, data }) => {
  const {
    _type,
    meta: { title },
    readTime,
  } = data;

  const isContentHubArticle = _type === "contentHubArticle";
  const content = isContentHubArticle
    ? data.contentHubArticleContent
    : { ...data.pressReleaseContent, tags: undefined, authors: undefined };
  const { articleDate, authors } = content;

  return (
    <ArticleContext.Provider
      value={{
        articleDate: formatContentHubArticleDate(articleDate),
        authors,
        readTime: readTime,
        title,
      }}
    >
      {children}
    </ArticleContext.Provider>
  );
};
